import React from 'react'
import { motion } from 'framer-motion'
import HeroSection from './pages/HeroSection'
import AboutSection from './pages/AboutSection'
import SkillsSection from './pages/SkillsSection'
import ExperienceSection from './pages/ExperienceSection'
import ProjectsSection from './pages/ProjectsSection'
import EducationSection from './pages/EducationSection'
import ContactSection from './pages/ContactSection'
import DockNavigation from './components/DockNavigation'

const App = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 overflow-x-hidden">
      {/* Background pattern */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-transparent via-transparent to-black/20"></div>
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+CiAgPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSIjZmZmIi8+CiAgPHBhdGggZD0iTTAgMGgyMHYyMEgweiIgZmlsbD0ibm9uZSIvPgo8L3N2Zz4=')] opacity-10"></div>
      </div>

      {/* Hero section - Fixed sidebar on desktop, regular section on mobile */}
      <HeroSection />

      {/* Main content - Adjusted for sidebar on desktop only */}
      <div className="relative z-10 md:ml-96 ml-0">
        <AboutSection />
        <SkillsSection />
        <ExperienceSection />
        <ProjectsSection />
        <EducationSection />
        <ContactSection />
      </div>

      {/* Dock navigation */}
      <DockNavigation />
    </div>
  )
}

export default App